// extracted by mini-css-extract-plugin
export default {"container":"DC-z","dimension":"EC-z","dimensionLabels":"FC-z"};